import React, { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';

import AskViso from 'components/AskViso';
import { withRouter } from 'withRouter'
import { compose } from 'redux';
import { handleMutation } from 'utils/request'
import { me } from 'api/users';

const availableNodes = [
  "video-feed-video-file",
  "video-feed-ip-camera",
  "video-feed-usb-camera",
  "object-detection",
  "object-detection-tracking",
  "visualization",
  "video-view",
  "inject",
  "function",
  "switch",
  "change",
  "delay",
  "filter",
  "mqtt out",
  "http request",
  "region-selection",
  "image-capture",
  "video-clip-capture",
  "incident-creation",
  "line-counting",
  "area-counting"
]

function getParams() {
  const params = new URLSearchParams(window.location.search);
  return {
    accessToken: params.get('accessToken'),
    refreshToken: params.get('refreshToken'),
    modeParam: params.get('mode')
  };
}

const AppBuilderAgentAi = ({ fetchMeRequest, user }) => {
  const { modeParam } = getParams();
  const [showPage, setShowPage] = useState(true)
  const [mode, setMode] = useState(modeParam)

  const [currentFlow, setCurrentFlow] = useState(null)
  const [accessKey, setAccessKey] = useState(null)
  const [insertFlowMessage, setInsertFlowMessage] = useState(null)

  const parentOriginRef = useRef('*');
  const requestedRef = useRef(false)

  const onSuccess = () => {
    setShowPage(true)
  }

  useEffect(() => {
    const fetchData = async () => {
      try {
        const { accessToken, refreshToken } = getParams();
        if (accessToken) localStorage.setItem('accessToken', accessToken);
        if (refreshToken) localStorage.setItem('refreshToken', refreshToken);

        const response = await me();
        handleMutation(response, onSuccess)
        requestedRef.current = true

      } catch (_) { }
    }
    // fetchData()


  }, [])

  // Listen for messages from parent
  useEffect(() => {
    function onMessage(ev) {
      // Validate origin against parent origin if known
      if (parentOriginRef.current !== '*' && ev.origin !== parentOriginRef.current) return;

      const data = ev.data;
      if (!data || typeof data !== 'object') return;

      switch (data.type) {
        case 'viso:openPanel':
          setMode(data.mode)
          break;
        case 'viso:setParentOrigin':
          if (typeof data.origin === 'string') {
            parentOriginRef.current = data.origin;
            try { window.parent && window.parent.postMessage && window.parent.postMessage({ type: 'viso:ready' }, parentOriginRef.current); } catch (_) { }
          }
          break;
        case 'viso:setAccessKey':
          if (typeof data.accessKey === 'string') setAccessKey(data.accessKey);
          break;
        case 'viso:existingFlow':
          if (data.flow) {
            const nodes = Array.isArray(data.flow) ? data.flow : data.flow.nodes;
            if (Array.isArray(nodes)) setCurrentFlow({ nodes });
          }
          break;
        case 'viso:insertFlow':
          if (data.message) {
            setInsertFlowMessage(data.message)
          }
          break;
        default:
          break;
      }
    }

    window.addEventListener('message', onMessage);
    return () => window.removeEventListener('message', onMessage);
  }, []);

  // Proactively inform parent that this iframe is ready to receive messages.
  // This avoids losing viso:openPanel if the parent sends it before the listener is attached.
  useEffect(() => {
    try {
      if (window && window.parent && typeof window.parent.postMessage === 'function') {
        window.parent.postMessage({ type: 'viso:ready' }, '*')
      }
    } catch (_) { }
  }, [])

  // useEffect(() => {
  //   if (!showPage) return
  //   const openAskViso = () => {
  //     try {
  //       const btn = document.getElementById('askViso')
  //       if (btn && typeof btn.click === 'function') btn.click()
  //     } catch (_) { }
  //   }
  //   // Defer to allow DOM to paint
  //   const t = setTimeout(openAskViso, 0)
  //   return () => clearTimeout(t)
  // }, [showPage])

  const onInsertNode = (formValues) => {
    if (window && window.parent) {
      window.parent.postMessage(
        { type: 'viso:insertFlow', flow: [], formValues },
        '*'
      );
    }
  };

  const closeParentPanel = () => {
    setMode([])
    if (window && window.parent) {
      window.parent.postMessage(
        { type: 'viso:closePanel' },
        '*'
      );
    }
  }

  return (
    <>
        <AskViso
          closeParentPanel={closeParentPanel}
          onInsertFlow={onInsertNode}
          existingFlow={currentFlow}
          openByDefault={true}
          availableNodes={availableNodes}
          externalAskMessage={insertFlowMessage}
          color='accent3'
          askMode={{ value: mode }}
          modeParam={modeParam}
          contextType='appBuilding' legacyPage />
    </>
  );
}

export default withRouter(
  compose(
    withRouter,
  )(AppBuilderAgentAi),
);